import 'moment/locale/en-gb';
import 'moment/locale/es';
import 'moment/locale/pt-br';
import { List } from '@mui/material';
import { Box } from '@mui/system';
import { CalendarDateLabel } from './CalendarDateLabel/CalendarDateLabel';
import { styles } from './styles';

type DateListProp = {
  selectedMonth: any;
  setSelectedMonth: any;
  setAllDays: any;
  allDays: any;
  dateItem: any;
};

export const DateList = ({
  selectedMonth,
  setSelectedMonth,
  setAllDays,
  allDays,
  dateItem,
}: DateListProp) => {
  return (
    <Box>
      <CalendarDateLabel
        month={selectedMonth}
        setMonth={setSelectedMonth}
        setAllDays={setAllDays}
      />
      <List sx={styles.list}>
        {allDays.map((date: any, index: any) => dateItem(date, index))}
      </List>
    </Box>
  );
};
